import React, { useState, useEffect, useCallback, useMemo } from 'react'
import DropDown from '../dropdown'
//import { SearchGuestByString } from '../../../api/services/crm'
import { Guests } from '../../../api/services/next'
import { GetFullName } from '../utils'
import { Popup, Form, Message } from 'semantic-ui-react'
import NationalitiesDropDown from '../NationalitiesDropDown';
import PropTypes from "prop-types";
import _ from 'lodash'
import uniqid from 'uniqid'
import { GuestAccountType } from '../constants'
import { useMessageResources, useTextResources } from '../../../language';
let searchAbort = null;

const GuestSearchDropDown = ({ onChange, popup, guest, onAddGuest, value, ...rest }) => {
    const [search, setSearch] = useState("")
    const [data, setData] = useState()
    const [title, setTitle] = useState("")
    const [lname, setLName] = useState("")
    const [fname, setFName] = useState("")
    const [idnumber, setIDNumber] = useState("")
    const [passport, setPassport] = useState("")
    const [email, setEmail] = useState("")
    const [mobile, setMobile] = useState("")
    const [nationality, setNationality] = useState("")
    const [showPopup, setShowPopup] = useState(false)
    const [popupContext, setPopupContext] = useState(null)
    const [_value, setValue] = useState(value)
    const text = useTextResources()
    const message = useMessageResources()

    const ref = useCallback(node => {
        if (node && node.ref) {
            setPopupContext(node.ref.current)
        }
    }, [])

    const abortSearch = ()=>{
        throttled.cancel()
        if (searchAbort){
            searchAbort.abort()
        }
    }
    const throttled = useMemo(() => _.throttle(async (search) => {
        searchAbort = new AbortController();
        const result = await Guests.Search({ search })
        if (!searchAbort.signal.aborted) {
            setData(result)
        }
    }, 400, { 'leading': false }), [])

    useEffect(() => {
        if (search === "") {
            setData()
        } else {
            throttled(search)
        }
    }, [search])

    useEffect(() => {
        if (onChange && _value != value) {
            onChange(_value)
        }
    }, [_value])

    useEffect(() => {
        setValue(value);
    }, [value])


    useEffect(() => {
        if (!guest && !value) {
            setData();
        } else if (guest) {
            cleanOldIdsProps()
            setData([guest]);
            setValue(guest.Id);
        }
        function cleanOldIdsProps() {
            if (guest.GuestAccountTypeID) {
                guest.GuestAccountTypeId = guest.GuestAccountTypeID
                guest.GuestAccountTypeID = undefined
            }
        }
    }, [guest])

    const searchGuests = (options) => {
        return options.filter(opt => opt.key != "addition");
    }

    const onAddItem = (e, { value }) => {
        abortSearch()
        var vals = value.split(" ");
        const firstName = vals[0]
        const lastName = vals.slice(1).join(" ")
        setLName(lastName)
        setFName(firstName)
        
        if (popup) {
            setShowPopup(true)
        } else {
            // if we already have a guest object, assume we are updating existing guest
            const isNewGuest = !guest?.Id
            const newGuest = isNewGuest?{
                Id: uniqid("newguest-"),
                FirstName: firstName,
                LastName: lastName,
                GuestAccountTypeId: GuestAccountType.Normal
            }:{
                ...guest,
                Id: guest.Id.startsWith('newguest-')?uniqid("newguest-"):guest.Id,
                FirstName: firstName,
                LastName: lastName
            }
            setData([newGuest])
            setTimeout(() => setValue(newGuest.Id), 0);
            if (onAddGuest) {
                onAddGuest(newGuest)
            }
        }
    }

    const addGuest = () => {
        setShowPopup(false)
    }

    const onChangeGuest = value => {
        if (Number.isInteger(value) && data?.find(x => x.Id === value)) {
            setValue(value)
        }
        else if (value == "") {
            setValue(null);
        }
    }

    const guestAccountTypeLabels = [
        { type: GuestAccountType.Normal, label: null },
        { type: GuestAccountType.Red, label: { color: 'red', empty: true, circular: true } },
        { type: GuestAccountType.Black, label: { color: 'black', empty: true, circular: true } }
    ]

    const guestLabel = React.useCallback(item => {
        if (item.GuestAccountTypeId) {
            var guestAccountTypeLabel = guestAccountTypeLabels.find(x => x.type === item.GuestAccountTypeId)
            return guestAccountTypeLabel?.label;
        }
        return null
    }, [])

    const getGuestAccountTypeMessage = useCallback(() => {
        const selectedGuest = data?.find(x => x.Id === _value);
        if (selectedGuest) {
            const guestAccountTypeId = selectedGuest.GuestAccountTypeId;
            if (guestAccountTypeId && guestAccountTypeId != GuestAccountType.Normal) {
                let warning = guestAccountTypeId == GuestAccountType.Black ? message("CustomerIsInBlackList") : message("CustomerIsInRedList");
                return <Message warning visible>{warning} </Message>
            }
        }
    }, [_value])

    const options = [
        { key: 'm', text: 'Mr', value: 'Mr' },
        { key: 'f', text: 'Mrs', value: 'Mrs' },
    ]

    return (
        <React.Fragment>
            <DropDown
                    ref={ref}
                    additionLabel={`${text("Create")} ${text("Or")} ${text("Update")}: `}
                    style={{ width: "100%" }}
                    data={data}
                    valueField={"Id"}
                    textField={GetFullName}
                    search={searchGuests}
                    descriptionField="Email"
                    allowAdditions
                    onAddItem={onAddItem}
                    onSearchChange={setSearch}
                    searchInput={{ style: { paddingLeft: "inherit" } }}
                    value={_value}
                    onChange={onChangeGuest}
                    labelField={guestLabel}
                    {...rest}
                />

            {getGuestAccountTypeMessage()}
            <Popup open={showPopup} context={popupContext} basic position="bottom center" flowing>
                <Popup.Header>Create new guest</Popup.Header>
                <Popup.Content>
                    <Form size="small">
                        <Form.Group>
                            <Form.Select
                                width="3"
                                label='Title'
                                options={options}
                                placeholder='Title'
                                fluid
                                value={title} onChange={(e, { value }) => setTitle(value)}
                            />
                            <Form.Input width="6" label='Last name' placeholder='Last name' value={lname} onChange={(e, { value }) => setLName(value)} />
                            <Form.Input width="7" label='First name' placeholder='First name' value={fname} onChange={(e, { value }) => setFName(value)} />
                        </Form.Group >
                        <Form.Group widths='equal'>
                            <Form.Input label='ID Number' placeholder='ID Number' value={idnumber} onChange={(e, { value }) => setIDNumber(value)} />
                            <Form.Input label='Passport' placeholder='Passport' value={passport} onChange={(e, { value }) => setPassport(value)} />
                        </Form.Group >
                        <Form.Group widths='equal'>
                            <Form.Input label='Email' placeholder='Email' type="email" value={email} onChange={(e, { value }) => setEmail(value)} />
                            <Form.Input label='Mobile' placeholder='Mobile' value={mobile} onChange={(e, { value }) => setMobile(value)} />
                        </Form.Group >
                        <Form.Field label="Nationality" control={NationalitiesDropDown} value={nationality} onChange={setNationality} />
                        <Form.Group>
                            <Form.Button positive onClick={addGuest}>Save</Form.Button>
                            <Form.Button negative onClick={() => setShowPopup(false)}>Cancel</Form.Button>
                        </Form.Group>
                    </Form>
                </Popup.Content>
            </Popup>
        </React.Fragment>
    )
}

GuestSearchDropDown.propTypes = {
    onChange: PropTypes.func,
    onAddGuest: PropTypes.func,
    guest: PropTypes.object,
    value: PropTypes.any,
    popup: PropTypes.bool
}
export default GuestSearchDropDown